import { RANK, ICON } from './leader-board-member.constants';

export function getImageRankBox(rank) {
    return RANK[rank - 1];
}

export function getIconRankBox(rank) {
    return ICON[rank - 1];
}
